/*
 * @Author: libo 
 * @Date: 2020-11-13 17:25:56 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-01-24 10:15:16
 */

<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :cancel-text="$t('关闭')">
    <meter-price-item-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></meter-price-item-form>
  </j-modal>
</template>

<script>

  import MeterPriceItemForm from './MeterPriceItemForm'
  export default {
    name: 'MeterPriceItemModal',
    components: {
      MeterPriceItemForm
    },
    data () {
      return {
        title:'',
        width:800,
        visible: false,
        disableSubmit: false,
        isUsed: false// 是否已使用
      }
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.isUsed = this.isUsed;
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.isUsed = this.isUsed;
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>